// react native に依存しない汎用モジュールのみ配置

/*
・immer の場合、_next を {} で直接上書いてはいけない模様
・await せずに promise を _o_end した場合、処理が終了しない場合がある（当然か）

・map 内部で list の要素を setState しない（特に clds の list）
　（map 中で immer を用いて要素ごとに setState とした場合、元の list を破壊し正しく動作しない模様）

npm install base-64 --save
npm install immer --save
npm install lz-string --save
npm install utf8 --save
npm install papaparse --save
expo install encoding-japanese
*/

// for immer
import { enableMapSet } from "immer"
enableMapSet()
import produce from "immer"

import lz from 'lz-string'; // npm install --save lz-string

import utf8 from 'utf8'; // npm install --save utf8

import {decode as atob, encode as btoa} from 'base-64' // npm install base-64 --save

import Papa from 'papaparse'; // CSV変換

import Encoding from 'encoding-japanese' // ファイル取込においてファイル形式を判別する際に必要

import ff from './ff';

export default class bf extends ff { // base function

  ////////////////////////////////////////////////////////////////////////

/*
  static i(pa_vals, pl_vals){ // check in
    if (ff.myCM_chkType(pa_vals, 'dct')) {
      let _r = pl_vals;
      for (let [_key, _val] of bf.e(pa_vals)) {
        if (_r) {
          _r = _r.filter( _d_is => {
            return (_d_is[_key] == _val)
          });
        }
        else {
          break;
        }
      }
      if (bf.f(_r)) {
        return true;
      }
      else {
        return false;
      };
    }
    else {
      if (pl_vals.indexOf(pa_vals)>=0) {
        return true;
      }
      else {
        return false;
      };
    };
  };
*/

  static p(pa_vals, po_fnc){ // produce, 同一の state の setState を重複させると正常に動作しない模様
    return produce(pa_vals, po_fnc);
  };

  //////////////////////////////////////////////////////////////////////// for common module
  static myCM_add_newKeyVal(pd_vals, pa_val) {
    let _newKey = bf.myCM_get_newKey(pd_vals);
    pd_vals[_newKey] = pa_val;
  };

/*
  static myCM_cnv(p_mode, pa_val){ // async の場合に Base64 が正しく動作しない場合がある模様
    if (p_mode == 'str') { // from json to string
      return String(pa_val); // 数値の場合
    };

    if (p_mode == 'ceil') { // 切り捨て
      return Math.ceil(pa_val);
    };
    //
    if (p_mode == 'cmm' || p_mode == 'comma') { // カンマ区切り
      let _l = String(pa_val).replace(/,/g, '').split('.');
      let _r = String(_l[0]).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      if (_l.length > 1) {
          _r += '.' + _l[1];
      }
      return _r;
    };

    if (p_mode == 'flr' || p_mode == 'floor') { // 切り捨て
      return Math.floor(pa_val);
    };

    if (p_mode == 'han') { // 半角
      return String(pa_val).replace( /[Ａ-Ｚａ-ｚ０-９]/g, (_s) => String.fromCharCode(_s.charCodeAt(0) - 65248));
    };

    if (p_mode == 'json') { // from string to json
      return JSON.parse(pa_val);
    };

    if (p_mode == 'list') { // from dictionary to list 
      return Object.entries(pa_val)
    };

    if (p_mode == 'nmb') { // from string to number 
      return parseFloat(pa_val)
    };

    if (p_mode == 'cps') { // compress
      return LZString.compress(pa_val)
    };

    if (p_mode == 'dcs') { // decompress
      return LZString.decompress(pa_val)
    };

    if (p_mode == 'ecdBase64') { // encode uri
      if (bf.f(pa_val)) {
        return btoa(utf8.encode(pa_val));
      }
      else {
        return null;
      };
    };

    if (p_mode == 'dcdBase64') { // decode uri
      if (bf.f(pa_val)) {
        return utf8.decode(atob(pa_val));
      }
      else {
        return null;
      };
    };

    alert('287: incorrect mode: {}'.f(p_mode))

  };
*/

  static myCM_ecd(p_mode, pa_val) {
    if (ff.f(pa_val) != true) {
      return null;
    }
    else {
      if (p_mode == 'base64') {
//ff.l('168: {}'.f(pa_val))
        return btoa(utf8.encode(pa_val));
      }
    }
  };

  static myCM_dcd(p_mode, pa_val) {
    if (ff.f(pa_val) != true) {
      return null;
    }
    else {
      if (p_mode == 'base64') {
        return utf8.decode(atob(pa_val));
      }
    }
  };

  static myCM_get_cldDct(pd_dcts, p_pid, pn_lyrDff=0){ // get child dictionary
    let _l_keys = p_pid.split(bf.dlm);
    let _n_lyr = bf.myCM_getLen(_l_keys);
    let _d_dcts = pd_dcts;
    for (let [_n_idx, _key] of _l_keys.entries()) {
      //
      if (_n_idx >= _n_lyr + pn_lyrDff) { // 親階層を取得する場合は pn_lyrDff = 1
        break;
      }
      //
      if (_n_idx == 0) {
        _d_dcts = _d_dcts[_key];
      }
      else {
        _d_dcts = _d_dcts.clds[_key];
      };
    };
    return [_d_dcts, _n_lyr];
  };

  static myCM_get_dct = (pd={ // ld_iss において fld == val である d_items を取得
    ld_iss: [{}],
    fld: '',
    val: '',
    mode: 'items/idx',
  }) => {
    let _r = null;
    for (let [_idx, _d_items] of bf.e(pd.ld_iss)) {
      if (_d_items[pd.fld] == pd.val) {
        _r = (pd.mode == 'idx') ? _idx : _d_items;
        break;
      }
    };
    return _r;
  };

  static myCM_get_keys(pd_vals){
    return Object.keys(pd_vals);
  };

  static myCM_get_newKey(pa_vals) {

    if (!bf.f(pa_vals)) {
        return 'new';
    };

    if (ff.myCM_chkType(pa_vals, 'dct')) {
      let _cnt = 1;
      let _newKey = '';
      while (true) {
        if (_cnt == 1) {
          _newKey = 'new';
        }
        else {
          _newKey = 'new{}'.f(_cnt);
        };
        if (pa_vals[_newKey]) {
          _cnt += 1;
        }
        else {
          break;
        };
      };
      return _newKey;
    };

    if (ff.myCM_chkType(pa_vals, 'list')) {
      let _cnt = 1;
      let _newKey = '';
      while (true) {
        if (_cnt == 1) {
          _newKey = 'new';
        }
        else {
          _newKey = 'new{}'.f(_cnt);
        };
        if (
          bf.myCM_get_dct({
            mode: 'items', 
            ld_iss: pa_vals, 
            fld:'_KEY', 
            val: _newKey
          })
        ) {
          _cnt += 1;
        }
        else {
          break;
        };
      };
      return _newKey;
    };

  };

  static myCM_get_substr(p_str, pn_from, pn_len){ // pn_from : 0
    return p_str.substr(pn_from, pn_len);
  };

  static myCM_push(pl_vals1, pl_vals2) {
    Array.prototype.push.apply(pl_vals1, pl_vals2); // 破壊的な配列の結合(新規配列の生成ではなく、一つ目の配列内容を変更)
  };
    
  static myCM_rmv(pl_vals, p_val) { // pl_vals から p_val を除外する
    return pl_vals.filter(_val => _val !== p_val);
  }

  static myCM_split(p_str, p_dlm){
    return p_str.split(p_dlm);
  };

  static myCM_sort = (pd={    
    ld_iss:[{}], 
    ld_sortss:[{fld:'_KEY', dtn:'asc', mode:'str/nmb'}], // myRN_call_slc の段階では key などがないことに注意
    type: 'dats',
  }) => { // p_mode: abs/desc, pld_valss: dct が sort 項目を持つこと, pl_keys が複数ある場合に対応要
    if ( pd.type == 'dats' ) { 
      if (bf.f(pd.ld_iss) && bf.f(pd.ld_sortss)) {
        let _ld_iss = pd.ld_iss?.slice(); // 元の並び順を壊さない（中の dct は同じものが引き継がれる）
        let _r = _ld_iss.sort((_a, _b) => {
          let _r2 = 0
          for (let [_idx, _d_sorts] of bf.e(pd.ld_sortss)) {
            let _mode = (_d_sorts.mode) ? _d_sorts.mode : 'str';
            let _sign = (_d_sorts.dtn == 'asc') ? 1 : ((_d_sorts.dtn == 'desc') ? -1 : 0); // sort 対象外とする場合を考慮
            let _valA = (_mode == 'nmb') ? bf.n(_a.d_flds[_d_sorts.fld]) : _a.d_flds[_d_sorts.fld];
            let _valB = (_mode == 'nmb') ? bf.n(_b.d_flds[_d_sorts.fld]) : _b.d_flds[_d_sorts.fld];
            if ((_valA < _valB) || (!_valA && _valB)) { // null の場合を考慮
              _r2 = -1 * _sign;
              break;
            } 
            else if ((_valA > _valB) || (_valA && !_valB)) { // null の場合を考慮
              _r2 = _sign;
              break;
            }
          };
          return _r2;
        });
        return _r;
      }
      else {
        return pd.ld_iss;
      };
    }
    else {
      if (bf.f(pd.ld_iss) && bf.f(pd.ld_sortss)) {
        let _ld_iss = pd.ld_iss?.slice(); // 元の並び順を壊さない（中の dct は同じものが引き継がれる）
        let _r = _ld_iss.sort((_a, _b) => {
          let _r2 = 0
          for (let [_idx, _d_sorts] of bf.e(pd.ld_sortss)) {
            let _mode = (_d_sorts.mode) ? _d_sorts.mode : 'str';
            let _sign = (_d_sorts.dtn == 'asc') ? 1 : ((_d_sorts.dtn == 'desc') ? -1 : 0); // sort 対象外とする場合を考慮
            let _valA = (_mode == 'nmb') ? bf.n(_a[_d_sorts.fld]) : _a[_d_sorts.fld];
            let _valB = (_mode == 'nmb') ? bf.n(_b[_d_sorts.fld]) : _b[_d_sorts.fld];
            if ((_valA < _valB) || (!_valA && _valB)) { // null の場合を考慮
              _r2 = -1 * _sign;
              break;
            } 
            else if ((_valA > _valB) || (_valA && !_valB)) { // null の場合を考慮
              _r2 = _sign;
              break;
            }
          };
          return _r2;
        });
        return _r;
      }
      else {
        return pd.ld_iss;
      };
    }
  };

  static myCM_upd(pd_vals1, pd_vals2) { // ディープコピーのため、元の配列は上書きされない
    if (bf.f(pd_vals1) && bf.f(pd_vals2)) {
      let _copy = bf.myCM_copy(pd_vals1);
      return Object.assign(_copy, pd_vals2);
    }
    else if (bf.f(pd_vals1) && !bf.f(pd_vals2)) {
      return bf.myCM_copy(pd_vals1);
    }
    else if (!bf.f(pd_vals1) && bf.f(pd_vals2)) {
      return bf.myCM_copy(pd_vals2);
    }
    else {
      return {};
    };
  };

  static myCM_join(pa_vals1, pa_vals2) { // ディープコピーのため、元の配列は上書きされない
    if (!bf.f(pa_vals1) && !bf.f(pa_vals2)) {
      return [];
    }
    else if (bf.f(pa_vals1) && !bf.f(pa_vals2)) {
      return pa_vals1;
    }
    else if (!bf.f(pa_vals1) && bf.f(pa_vals2)) {
      return pa_vals2;
    }
    else if (bf.f(pa_vals1) && bf.f(pa_vals2)) {
      let _copy = bf.myCM_copy(pa_vals1);
      return _copy.concat(pa_vals2);
    }
  };

/*
  static myCM_clw(pn_sec, po_fnc) { // clock work
    return new Promise((_resolve) => {
      let _id = setInterval(()=>{
        if (po_fnc()) {
          clearInterval(_id);
          _resolve();
        };
      }, pn_sec * 1000)
    });
  };
*/

  static myCM_cpt(p_mode, pa_val, p_srt_key='hogehoge') { // cpt: crypt, srt: secret 毎回暗号が変わるため、QRには向かない？
    //
    if (!bf.f(pa_val)) {
      return null;
    }
    else {
      if (p_mode == 'e') { // encrypt
        //const _js = require("crypto-js");
        //return _js.AES.encrypt(bf.s({tgt: pa_val}), p_srt_key).toString(); // not sure, but you have to wrap the value with object and stringify them.
        //return CryptoJS.AES.encrypt(bf.s({tgt: pa_val}), p_srt_key).toString(); // not sure, but you have to wrap the value with object and stringify them.
        return bf.s(pa_val);
        //return lz.compress(bf.s(pa_val));
      };

      if (p_mode == 'd') { // decrypt
        //const _js = require("crypto-js");
        //return bf.j(_js.AES.decrypt(pa_val, p_srt_key).toString(_js.enc.Utf8))?.tgt;
        //return bf.j(CryptoJS.AES.decrypt(pa_val, p_srt_key).toString(CryptoJS.enc.Utf8))?.tgt;
        //return bf.j(CryptoJS.AES.decrypt(pa_val, p_srt_key).toString(CryptoJS.enc.Utf8))?.tgt;
        return bf.j(pa_val);
        //return bf.j(lz.decompress(pa_val));
      };
    };
  };

  static myCM_hash(p_val) {
    //
    if (!bf.f(p_val)) {
      return null;
    }
    else {
      //const _js = require('crypto');
      //return _js.createHash('sha256').update(p_val, 'utf8').digest('hex');
//      return CryptoJS.createHash('sha256').update(p_val, 'utf8').digest('hex');
//      return bf.myCM_cpt('e', p_val, '0z9k2mfGgkaifkg1AfggbFBf0z9k2mfGgkaifkg1AfggbFBf');
      return p_val;
    };
  };

  //////////////////////////////////////////////////////////////////////// for date-time
  static myCM_cnvCsvToJson = (p_csv) => new Promise( _o_end1 => {
    Papa.parse(p_csv, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      delimiter: ',',
      transformHeader: h => h.replace(/\"/g, '').trim(), // 見出しの無効な \" を除去
      linebreak: '\n',
      complete: _d_rs => {
        _d_rs.ld_iss = _d_rs.data; // 命名規則を合わせるための言い換え
        _d_rs.data = null; // 命名規則を合わせるための言い換え
        _o_end1(_d_rs);
      },
    });
  });

  static myDT_flr_mnt(p_dtm, pn_mnt) { // floor
    let _dtm = new Date(p_dtm);
    _dtm.setMinutes(((_dtm.getMinutes() / pn_mnt) | 0) * pn_mnt);
    _dtm.setSeconds(0);
    return bf.myDT_cnv('dtm-fmt', _dtm);
  };

  static myDT_get_dates(p_mth) { // list of the day for the month
    let _ldm = bf.myDT_get_ldm(p_mth);
    let _dtm = bf.myDT_get_fdm(p_mth);
    let _r = [_dtm];
    while (true) {
      _dtm = bf.myDT_add_date(_dtm, 1);
      _r.push(_dtm);
      if (_dtm == _ldm) {
        break;
      };
    };
    return _r;
  };

  static myDT_get_day(p_dtm) { // get week day
    let _dtm = new Date(p_dtm);
    return _dtm.getDay();
  };

  static myDT_get_fdm(p_mth) { // fdm : first day of the month
    let _dtm = new Date(p_mth.substr(0,7)+'-01');
    return bf.myDT_cnv('date-fmt', _dtm);
  };

  static myDT_get_ldm(p_mth) { // ldm : last day of the month
    let _dtm = new Date(p_mth.substr(0,7)+'-01');
    _dtm.setMonth(_dtm.getMonth() + 1);
    _dtm.setDate(0);
    return bf.myDT_cnv('date-fmt', _dtm);
  };

  static myDT_get_mth() {
    let _now = new Date();
    let _MM = _now.getMonth()+1;
    if (_MM < 10) {_MM = '0' + _MM};
    return _MM;
  };

  static myDT_get_year() {
    let _now = new Date();
    let _YYYY = _now.getFullYear();
    return _YYYY;
  };

  static myDT_getNow() {
    let _dtm = new Date();
    return bf.myDT_cnv('dtm-fmt', _dtm);
  };

  static myFL_read(pd={
    mode: 'text/csv',
    o_file: null,
  }) {
    return new Promise( _o_end1 => {
      if (pd.mode == 'text') {
        let reader = new FileReader();
        reader.readAsBinaryString(pd.o_file);
        reader.onload = (_evt) => {
          const _ary = bf.myCM_cnv('str-ary', _evt.target.result);
          const _ecd = Encoding.detect(_ary);
          const _ucd = Encoding.convert(_ary, {
            to: 'unicode',
            from: _ecd,
            type: 'string'
          });
          _o_end1(_ucd);
        };
      }
      else if (pd.mode == 'csv') {
        let reader = new FileReader();
        reader.readAsBinaryString(pd.o_file);
        reader.onload = (_evt) => {
          const _ary = bf.myCM_cnv('str-ary', _evt.target.result);
          const _ecd = Encoding.detect(_ary);
          const _ucd = Encoding.convert(_ary, {
            to: 'unicode',
            from: _ecd,
            type: 'string'
          });
          bf.myCM_cnvCsvToJson(_ucd)
          .then( _d_rs => {
            _o_end1(_d_rs);
          })
        };
      }
      else {
        alert('incorrect mode at myFL_read.');
      };
    });
  };

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
